import { render, staticRenderFns } from "./NewPublicidad.vue?vue&type=template&id=3a13d41a&"
import script from "./NewPublicidad.vue?vue&type=script&lang=js&"
export * from "./NewPublicidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports